import { Col, Flex, Row } from 'antd'
/**
 * returns JSX for top players and teams
 */
function TopPlayersAndTeams() {
  return (
    <>
      {/* navigation */}
      <Flex vertical gap="20px">
        <Row gutter={10} className="main-navigation">
          <Col>
            <Flex
              gap="10px"
              className="main-navigation__heading"
              align="center"
            >
              <h3>Top Players and Teams</h3>
            </Flex>
          </Col>
        </Row>
      </Flex>
    </>
  )
}

export default TopPlayersAndTeams
